<div
  class="min-h-screen relative pb-16 font-['Poppins',_sans-serif] text-neutral-100 overflow-x-hidden selection:bg-neutral-800 selection:text-white bg-black">
  <!-- Dynamic Background Elements -->
  <div class="fixed inset-0 pointer-events-none z-0 overflow-hidden bg-black">
    <img *ngIf="sessionData?.device?.background_image_url" [src]="sessionData.device.background_image_url"
      class="absolute inset-0 w-full h-full object-cover opacity-80" alt="Background">
    <!-- Abstract blurred shapes to create the S-curve wave -->
    <!-- Top Right Glow -->
    <div
      class="absolute -top-[10%] right-[0%] w-[60vw] h-[60vw] bg-white rounded-full mix-blend-screen filter blur-[80px] opacity-80 sm:blur-[120px]">
    </div>

    <div
      class="absolute top-[40%] -left-[10%] w-[50vw] h-[50vw] bg-neutral-400 rounded-full mix-blend-screen filter blur-[70px] opacity-50 sm:blur-[100px]">
    </div>

    <div
      class="absolute -bottom-[10%] -left-[10%] w-[70vw] h-[70vw] bg-white rounded-full mix-blend-screen filter blur-[90px] opacity-70 sm:blur-[140px]">
    </div>

    <div class="absolute inset-0 opacity-20 mix-blend-overlay"
      style="background-image: url('data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E');">
    </div>
  </div>

  @if (isLoading && !sessionData) {
  <div class="relative z-10 min-h-screen flex flex-col items-center justify-center">
    <div class="w-12 h-12 border-4 border-white/20 border-t-white rounded-full animate-spin mb-4"></div>
    <div class="text-white/70 font-medium tracking-widest text-xs uppercase animate-pulse">Memuat Data...</div>
  </div>
  }

  @if (sessionData || !isLoading) {
  <div class="relative z-10 w-full max-w-sm sm:max-w-xl md:max-w-3xl lg:max-w-5xl xl:max-w-6xl mx-auto px-4 sm:px-8 pt-5 sm:pt-12 flex flex-col items-center animate-fade-in pb-16">

    <!-- Header Logo -->
    <div class="mb-6 sm:mb-8 md:mb-12 w-full flex justify-center drop-shadow-md">
      <img [src]="sessionData?.device?.logo_url || '/logo-photobooth-by-awh.svg'" alt="Photobooth Logo"
        class="h-14 sm:h-20 md:h-28 lg:h-36 xl:h-44 w-auto object-contain drop-shadow-xl">
    </div>

    <!-- Main Content Card -->
    <div
      class="bg-white rounded-[24px] sm:rounded-[36px] md:rounded-[48px] p-5 sm:p-9 md:p-12 lg:p-14 shadow-xl border border-neutral-200 w-full mb-8 flex flex-col items-center hover:shadow-md transition-shadow">

      <!-- Framed Photos -->
      @if (sessionData?.framed_photos?.length) {
      <div (click)="openModal(sessionData.framed_photos[0].url, 'framed_photo.jpg')"
        class="w-full mb-5 relative group bg-neutral-100 rounded-xl sm:rounded-2xl shadow-inner overflow-hidden border border-neutral-200 cursor-pointer">
        <img [src]="sessionData.framed_photos[0].url"
          class="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105" alt="Framed Photo">
        <div class="absolute inset-0 bg-black/10 mix-blend-multiply"></div>
      </div>
      }

      <!-- Footer Info of Card -->
      <div class="flex items-end justify-between w-full mt-2 pt-4 border-t border-neutral-100 relative">
        <div class="flex items-center gap-2.5 sm:gap-3 min-w-0 flex-1">

          <div
            class="relative w-12 h-12 sm:w-16 sm:h-16 bg-neutral-100 rounded-full flex items-center justify-center border border-neutral-200 shadow-sm flex-shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 sm:h-8 sm:w-8 text-neutral-400" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div class="absolute -top-1 -left-1 bg-black rounded-full p-0.5 border-2 border-white shadow-sm">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-2.5 w-2.5 sm:h-3 sm:w-3 text-white" viewBox="0 0 20 20"
                fill="currentColor">
                <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd" />
              </svg>
            </div>
          </div>

          <div class="text-left text-xs text-neutral-800 space-y-0.5 min-w-0 flex-1">
            <div class="font-bold flex items-center gap-1.5 text-[10px] sm:text-[11px] uppercase tracking-wide truncate">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 flex-shrink-0" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              <span class="truncate">{{ sessionData?.device?.name || 'Device' }}</span>
            </div>
            <div class="font-bold text-[10px] sm:text-xs text-neutral-600 truncate">Nama : {{ sessionData?.order?.name || '-' }}</div>
            <div class="font-bold text-[10px] sm:text-xs text-neutral-600 truncate">PIN : {{ sessionData?.pin || '-' }}</div>
          </div>
        </div>

        <div
          class="bg-black text-white text-[8px] font-black tracking-wider px-2.5 py-1 sm:px-3 sm:py-1.5 rounded-full shadow-sm uppercase flex-shrink-0">
          SUDAH FOTO
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Modal Popup for Full Screen Photo -->
  @if (isModalOpen) {
  <div
    class="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/95 backdrop-blur-md animate-fade-in p-4 overflow-y-auto">

    <!-- Close Button (Top Right) -->
    <button (click)="closeModal()"
      class="absolute top-4 right-4 sm:top-8 sm:right-8 text-white/70 hover:text-white p-3 sm:p-4 rounded-full bg-neutral-900/60 hover:bg-neutral-800 transition-all focus:outline-none z-50 shadow-xl"
      aria-label="Close modal">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 sm:h-10 sm:w-10 md:h-12 md:w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>

    <!-- Photo Container -->
    <div class="relative max-w-full max-h-[65vh] sm:max-h-[72vh] px-2 sm:px-6 flex justify-center items-center select-none animate-scale-in my-auto"
      (click)="$event.stopPropagation()">
      <img [src]="selectedPhotoUrl"
        class="max-w-full max-h-[65vh] sm:max-h-[72vh] object-contain rounded-xl sm:rounded-2xl shadow-2xl border border-neutral-800"
        [alt]="selectedPhotoName">
    </div>

    <!-- Download & Action Buttons -->
    <div class="mt-4 sm:mt-8 flex flex-col items-center gap-3 sm:gap-4 px-4 w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl z-50 animate-scale-in"
      (click)="$event.stopPropagation()">
      <button (click)="downloadPhoto(selectedPhotoUrl, selectedPhotoName)"
        class="w-full bg-white text-black py-3.5 sm:py-5 md:py-6 px-6 sm:px-10 rounded-full font-black text-xs sm:text-base md:text-xl tracking-wide hover:bg-neutral-200 active:scale-95 transition-all shadow-2xl flex items-center justify-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 sm:h-6 sm:h-6 md:h-7 md:w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
        </svg>
        Download Photo
      </button>

    </div>

    <!-- Backdrop click to close -->
    <div class="absolute inset-0 z-40 cursor-default" (click)="closeModal()"></div>
  </div>
  }

  @if (isDownloading) {
  <div class="fixed bottom-6 right-6 z-50 bg-slate-900/90 text-white px-5 py-3.5 rounded-2xl shadow-2xl flex items-center gap-3 border border-white/10 backdrop-blur-md animate-bounce">
    <div class="w-5 h-5 border-2 border-pink-400 border-t-transparent rounded-full animate-spin shrink-0"></div>
    <span class="text-xs sm:text-sm font-semibold tracking-wide">Mengunduh foto ke perangkat...</span>
  </div>
  }
</div>